module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAABGklEQVRoQ93ayw3CQAwE0EkHlAIdQCVAZVASdEIJaKVEinJASnY+Jnv2YZ/ty0gesJM37MSBapADgM+W5laCPAAcAVy2YKpAGuI2TuIF4LR2KhUgc0T7/x3A898gFERDJydCQyQhVEQKQkckIBKEGyJDOCFShAsiRzggFoQaYkMoIVaECmJHKCARBBsSQzAhUQQLEkcwICUQvZAyiB5IKUQPpGXq6yxXb8rZa3P5r/qeqFsK0wNpDSqD6YWUwTAgJTAsSBzDhEQxbEgMo4BEMCqIHaOEWDFqiA3jgFgwLogc44RIMW6IDJOASDApCB2ThFAxaQgNUwGyxLzHC4hVkb4KZMK0E47zP59wTN3fxVHNqlVaFldarS7IFzSdWjMfaV2JAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/Back_50.png
// module id = 68
// module chunks = 2